import { type Filters } from 'react-table';

import { type ReportsFilters } from 'components/panels/reports/utils';
import { type ScheduleTableDataType } from 'components/scheduleDisplay/CourtsSchedule';
import { type MatchUpInterface } from 'typedefs/store/scheduleTypes';
import { type ParticipantInterface } from 'typedefs/store/tmxTypes';

export enum DrawAdditionalPlayerInformation {
  'NONE' = 'NONE',
  'CITY_STATE' = 'CITY_STATE',
  'DISTRICT' = 'DISTRICT',
  'SECTION' = 'SECTION',
  'COUNTRY' = 'COUNTRY',
  'TEAM' = 'TEAM',
  'CONFERENCE' = 'CONFERENCE',
  'REGION' = 'REGION',
}

export enum DrawAdditionalPlayerInformationLabel {
  'NONE' = 'None',
  'CITY_STATE' = 'City/State',
  'DISTRICT' = 'District',
  'SECTION' = 'Section',
  'COUNTRY' = 'Country',
  'TEAM' = 'Team',
  'CONFERENCE' = 'Conference',
  'REGION' = 'Region',
}

export enum DrawMatchDayInformation {
  DATE = 'DATE',
  TIME = 'TIME',
  FACILITY = 'FACILITY',
}
export enum Adornments {
  NONE = 'NONE',
  WTN = 'WTN',
}
export enum AdornmentsDisplay {
  NONE = 'None',
  WTN = 'WTN',
}
export enum AdornmentsDraw {
  NONE = 'none',
  WTN = 'wtn',
  CUSTOM = 'custom',
}

export interface DrawMatchDayInformationForDate {
  selectedInformation: DrawMatchDayInformation[];
  dates: string[];
}

export interface TournamentDeskUISettings {
  playersColumns?: Array<string>;
  playersFilters?: Filters<ParticipantInterface>;
  teamsColumns?: Array<string>;
  teamsFilters?: Filters<ParticipantInterface>;
  matchUpsColumns?: Array<string>;
  matchUpsFilters?: Filters<MatchUpInterface>;
  singlesDoublesSelectedColumns?: Array<string>;
  singlesDoublesAlternateColumns?: Array<string>;
  singlesDoublesWithdrawnColumns?: Array<string>;
  singlesDoublesQualifyingColumns?: Array<string>;
  teamsSelectedColumns?: Array<string>;
  teamsAlternateColumns?: Array<string>;
  teamsQualifyingColumns?: Array<string>;
  teamsAlternatePlayersColumns?: Array<string>;
  teamsAvailablePlayersColumns?: Array<string>;
  teamsWithdrawnTeamsColumns?: Array<string>;
  teamsWithdrawnPlayersColumns?: Array<string>;
  unpairedColumns?: Array<string>;
  reportsFilters?: ReportsFilters;
  scheduleColumns?: Array<string>;
  scheduleFilters?: Filters<ScheduleTableDataType>;
}

export interface InitialDrawDisplaySettings {
  settings?: {
    draw?: DrawSettings;
    tournamentDeskUI?: TournamentDeskUISettings | null;
    virtualTournamentCheckIn?: boolean;
    virtualMatchUpCheckIn?: boolean;
  };
}

export interface DrawSettings {
  additionalPlayerInformation?: DrawAdditionalPlayerInformation[];
  matchDayInformation?: DrawMatchDayInformationForDate[];
  playerAdornment?: Adornments;
  showEntryStatus?: boolean;
}
